import React, { Component } from "react";
import { message, Spin } from "antd";
import { Descriptions, Form, Input, Select, Modal, Button, Row, DatePicker } from 'antd'
import "./index.less";
import sha1 from '../../../utils/sha1'
import axios from "axios";
import {
	submitTitle,
	getQrInvoiceInfoById,
	gsDataFind,
	getWxCardPkgAuthUrlFromFPTime,
} from "../../../api/index.js";
//const wx = require('jweixin-wechat')
const { Option } = Select;
let wx = window.wx
export default class index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lodding:false,
			invoiceNumber: "", //id值
			show: false,
			toggle: true,
			orderNo: "",
			tdyslxdm: "",
			jshj: "",
			search: [],
			bdcInfo:{
                region: '',
                realEstateUnitCode: '',
                detailedAddress: '',
                crossCitySign: '1',
                areaUnit: 'm²',
                fwcqzshm: '',
                leaseTerm: '',
                zlqq: '',
                zlqz: '',
                titleNo: '' 
            },
			form: {
				id: "",
				buyerName: "",
				buyerRegistNo: "",
				buyerAddressAndPhone: "",
				buyerPhone: "", //公司电话
				buyerAddress: "", //公司地址
				buyerBankNameAndNO: "",
				buyerBankName:"", 
				buyerBankNo:'',
				email: "",
				phone: "",
			},
			display:false,
			showBlock:false,
		}
		this.environmental = "micromessenger2";
		this.emailList = [];
	}
	componentDidMount() {
		
		let form = this.state.form;
		form.id = this.GetQueryString("id");
		
		this.setState({
			invoiceNumber: form.id,
			form,
		});
		this.init(form.id);
		//检测坏境
		var userAgent = navigator.userAgent.toLowerCase();

		if (userAgent.match(/Alipay/i) == 'alipay') {
			this.environmental = "alipay";
		} else if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
			this.environmental = "micromessenger";
			this.setState({
				display:true
			})
			this.isWX()
		}else{
			this.setState({
				display:false
			})
		}
	}

	init(id) {
		getQrInvoiceInfoById({ id }).then((res) => {
			message.info(res.msg);
			if (res.code === "0000") {
				var tdyslxdm = ''
				var spbm = JSON.parse(res.resultObj.fyxmJson)[0].spbm  
				if(spbm.startsWith('304050')){
					tdyslxdm = '06'
				}else if (spbm.startsWith("5010299000000000000") || spbm.startsWith("5030000000000000000")  ){
					tdyslxdm = '05'
				}
				this.setState({
					orderNo: res.resultObj.orderNo,
					jshj: res.resultObj.jshj,
					tdyslxdm: tdyslxdm
				});
			}
		});
	}
	
	// change(e) {
	// 	if (e.target.value !== "") {
	// 		this.setState({
	// 			invoiceNumber: e.target.value,
	// 		});
	// 	}
	// }

	//申请发票
	writeInvoice() {
		let form = this.state.form;
		form.id = this.state.invoiceNumber;

		var reg1 = /^([a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}|[a-zA-Z0-9]{20})$/;
		var reg3 = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;

		if (form.buyerName === "") {
			message.warning("购方名称不能为空！");
			return false;
		}
		if (form.email === "") {
			message.warning("邮箱不能为空！");
			return false;
		}
		if (!reg3.test(form.email)) {
			message.warning("邮箱格式错误！");
			return false;
		}

		if (this.state.toggle) {
			if (form.buyerRegistNo === "") {
				message.warning("购方税号不能为空!");
				return false;
			}
			if (form.buyerRegistNo !== "" && !reg1.test(form.buyerRegistNo)) {
				message.warning("购方税号格式错误!");
				return false;
			}
		}else{
			form.buyerRegistNo = ""
			form.buyerPhone = ""
			form.buyerAddress = ""
			form.buyerBankNameAndNO = ""
			form.buyerBankName = ""
			form.buyerBankNo = ""
		}
		form.buyerAddressAndPhone = form.buyerAddress + form.buyerPhone;
		form.buyerBankNameAndNO = form.buyerBankName + form.buyerBankNo;
		for(let key in form){
			if(form[key] && typeof form[key]=="string"){
				form[key] = (form[key]).trim()
				form[key] = (form[key]).replace(/null|undefinde/g,"")
			}
		}
		
        // let param2 ={

        // };
        // if(this.state.tdyslxdm == '05'){
        //     param2.realEstateSale = this.state.bdcInfo;
        //     if( this.state.bdcInfo.areaUnit === '' ||  this.state.bdcInfo.region === '' || this.state.bdcInfo.detailedAddress === ''   ){
        //         return message.error('请填写不动产信息，此为必填项（注意格式）')
        //     }
        //     form.param2 = JSON.stringify(param2);
        // }else if (this.state.tdyslxdm == '06'){
        //     param2.realEstateRentalService = this.state.bdcInfo;
        //     if( this.state.bdcInfo.areaUnit === '' ||  this.state.bdcInfo.region === '' || this.state.bdcInfo.detailedAddress === ''   ||
        //         this.state.bdcInfo.zlqq  === '' || this.state.bdcInfo.zlqz   === '' || this.state.bdcInfo.zlqz.titleNo === ''
        //      ){
        //         return message.error('请填写不动产信息，此为必填项（注意格式）')
        //     }
        //     param2.realEstateRentalService.leaseTerm = this.state.bdcInfo.zlqq + " " + this.state.bdcInfo.zlqz
        //     form.param2 = JSON.stringify(param2);
        // }


		this.setState({lodding:true})
		submitTitle(form).then((res) => {
			if (res.code == "0000") {
				message.success(res.msg);
				try{
					let {pdfUrl,id} = res.resultObj
					localStorage.setItem("step_pdfUrl",pdfUrl)
					localStorage.setItem("step_id",id)
				}catch{
					return message.error('数据发生错误！')
				}
				if(this.environmental = 'micromessenger'){
					this.props.history.push({ pathname: '/takeInvoice/success' })
				}
			} else {
				if((res.msg).includes("税控设备无返回信息")){
					message.error("此盘无发票，请联系商家！");
				}else{
					message.error(res.msg);
				}
			}
			this.setState({lodding:false})
		});
	}
	//检索抬头
	searchInvocie(name) {
		gsDataFind({ searchName: name, token: "WxDev", }).then((res) => { 
		// axios.post(process.env.REACT_APP_BASEURL+"/registNoSearch?searchName="+name+'&token=WxDev').then((res) => {
		// 	res = res.data
			this.setState({
				search: [],
			},()=>{
				try{
					if (Array.isArray(res.object)&&res.object.length > 0) {
						this.setState({
							search: [...res.object],showBlock:true
						});
					}
				}catch{}
			});
		});
	}

	//选择购方名称
	selectOptions(id, name) {
		let form = this.state.form;
		form.buyerRegistNo = id;
		form.buyerName = name;
		this.setState({
			form,showBlock:false
		});
	}

	inputFocus=(val)=>{
		if(!val)return
		this.searchInvocie(val)
	}
	

	inputOnBlur=()=>{
		setTimeout(()=>{
			this.setState({
				showBlock:false
			});
		},100)
	}

	//更新数据
	updateData = (e, key) => {
		let form = this.state.form;
		form[key] = e.target.value.trim();
		if(key==="gfnsrsbh"){
			form[key] = form[key].toUpperCase()
		}
		if (key === "buyerName") {
			form.buyerRegistNo = ""
			this.searchInvocie(e.target.value);
		}
		// if (key === "email") {
		// 	this.emailSearch(e.target.value);
		// }
		this.setState({
			form,
		});
	};

	//清空数据
	deleForm=()=>{
		let form = {...this.state.form};
		for(let key in form){
			form[key]=""
		}
		this.setState({form})
	}

	//设置email
	selectEmaik(item){
		let form = this.state.form
		let email = item.props.children[1]
		form.email = email
		this.setState({
			form,
		})
		this.emailList = [];
	}
	//获取抬头
	selectInvoice() {
		this.getWx();
	}
	//验证微信环境
	isWX() {
		let param = { openId: "123" };
		axios.get(process.env.REACT_APP_BASEURL_WX+"/wxDev/getTicket", { params: param }).then((res) => {
				if (res.data.code == 0) {
					var time = Date.parse(new Date()),
						rstring = this.random_string(16),
						url =window.location.href.split("#")[0],
						ticket = res.data.map.ticket,
						str ="jsapi_ticket=" + ticket +"&noncestr=" + rstring + "&timestamp=" + time +"&url=" + url,
						str1 = sha1(str);
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: "wx20db3f2d2972db19", // 必填，公众号的唯一标识
						timestamp: time,
						beta: true,
						nonceStr: rstring,
						signature: str1,
						jsApiList: [
							// 'scanQRCode',
							"chooseInvoice",
							"chooseInvoiceTitle",
						],
					});
					wx.error(function (res) {
						axios
							.post(
								process.env.REACT_APP_BASEURL_WX+"/wxDev/reFreshTicket?openId=14555"
							)
							.then((res) => {
								if (res.data.code == "0") {
								} else {
									//window.location.reload();
								}
							})
							.catch((err) => {
								console.log("失败");
							});
					});
				}
			});
	}

	
    onChangeBdc = (key, e) => {
        this.state.bdcInfo[key] = e.target.value
        this.setState({ ...this.state })
    }
    onChangeBdc1 = (key, e) => {
        this.state.bdcInfo[key] = e
        this.setState({ ...this.state })
    }
	//拼接
	random_string(len) {
		var len = len || "4";
		var s = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
		if (len < 1) {
			alert("请设置一个大于0的数字为该字符串的长度！");
		} else {
			var str = '',
					p = '';
			for (var i = 0; i < len; i++) {
				p = parseInt(Math.random() * 100 % 62);
				str = str + s[p];
			}
			return str;
		}
	}
	//微信抬头
	getWx() {
		let that = this.state
		let myThis = this
		wx.invoke(
			"chooseInvoiceTitle",
			{
				scene: "1",
			},
			function (res) {
				if (res.err_msg === "chooseInvoiceTitle:ok" || res.err_msg === "ok") {

					res = JSON.parse(res.choose_invoice_title_info);
					if (res.taxNumber || res.companyAddress || res.telephone || res.BankName || res.bankAccount) {
						that.form.buyerName = res.title?res.title:"";
						that.form.buyerRegistNo = res.taxNumber?res.taxNumber:"";
						that.form.buyerPhone = res.telephone?res.telephone:"";
						that.form.buyerAddress = res.companyAddress?res.companyAddress:"";
						// that.form.buyerBankNameAndNO = `${res.BankName?res.BankName:""}${res.bankAccount?res.bankAccount:""}`;
						that.form.buyerBankName = res.BankName?res.BankName:"";
						that.form.buyerBankNo = res.bankAccount?res.bankAccount:"";
						if(!myThis.state.show){
							myThis.refs.oneCheckbox.click()
						}
						myThis.setState({toggle:true})
					} else {
						//个人
						that.form.buyerName = res.title?res.title:"";
						that.form.buyerRegistNo = '';
						that.form.buyerPhone = '';
						that.form.buyerAddress = '';
						// that.form.buyerBankNameAndNO ='';
						that.form.buyerBankName = "";
						that.form.buyerBankNo = "";
						if(myThis.state.show){
							myThis.refs.oneCheckbox.click()
						}
						myThis.setState({toggle:false})
					}
				}
			}
		);
	}
	//邮箱检索
	emailSearch(e) {
		this.emailList = [];
		var email = e;
		email = email.replace(/\s+/g, "");
		var mail = [
				"@qq.com",
				"@sina.com",
				"@163.com",
				"@gmail.com",
				"@sohu.com",
				"@qq.com",
				"@126.com",
				"@163.com",
				"@hotmail.com",
				"@yahoo.com",
			],
			idx = email.lastIndexOf("@");
		if (idx !== -1) {
			for (var i = 0; i < mail.length; i++) {
				this.emailList.push(
					<li
						key={i}
					>
						{" "}
						{email.slice(0, idx) + mail[i]}{" "}
					</li>
				);
			}
		} else {
			for (var j = 0; j < mail.length; j++) {
				this.emailList.push(
					<li
						key={j}
					>
						{" "}
						{e + mail[j]}{" "}
					</li>
				);
			}
		}
		// console.log('emailList',this.emailList);
	}
	//

	GetQueryString(kValue) {
		//当前页面的地址
		const url = window.location.href;
		var reg = /([^?&=]+)=([^?&=]+)/g,
			obj = {},
			str = url;
		url.replace(reg, function () {
			obj[arguments[1]] = arguments[2];
		});
		for (var keyName in obj) {
			if (keyName == kValue) {
				return obj[keyName];
			}
		}
	}
	render() {
		const form = this.state.form;
		return (
			<Spin spinning={this.state.lodding} size="large"  >
			<div className="invoice_warp">
				<div className="center">
					<div className="logo">
						<img
							src={require("../../../assets/img/headerLogo/header_logo.png")}
							alt=""
						/>
					</div>
					<div className="info">
						<p>增值税电子普通发票</p>
						<ul>
							<li>
								<span>
									订&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;号:
								</span>
								<span>{this.state.orderNo}</span>{" "}
							</li>
							<li>
								<span>开票总金额:</span>
								<span>{this.state.jshj}元</span>
							</li>
						</ul>
						<div className="wavy-line"></div>
					</div>
					<div className="form">
						{/*<div className="invoiceBtn" >*/}
						{/*	<button style={{display:this.state.display?'inline-block':'none'}}*/}
						{/*		onClick={() => {*/}
						{/*			this.selectInvoice();*/}
						{/*		}}*/}
						{/*	>*/}
						{/*		+选择发票抬头*/}
						{/*	</button>*/}
						{/*</div>*/}
						<div className="type">
							<span
								onClick={() => {
									this.deleForm()
									if(this.state.show){
										this.refs.oneCheckbox.click()
									}
									this.setState({ toggle: false });
								}}
								style={{ borderBottom: !this.state.toggle ? "2px solid #1C7FF3" : "", }}
							>
								个人/其他
							</span>
							<span
								onClick={() => {
									this.deleForm()
									this.setState({ toggle: true });
									// if(!this.state.show){
									// 	this.refs.oneCheckbox.click()
									// }
								}}
								style={{ borderBottom: this.state.toggle ? "2px solid #1C7FF3" : "", }}
							>
								企业
							</span>
						</div>
						<ul>
							<li>
								<label>
									<i>*</i>购方名称
								</label>
								<input autoComplete="off"
									placeholder="请输入抬头名称、智能检索"
									value={form.buyerName}
									onChange={(e) => {
										this.updateData(e, "buyerName");
									}}
									onBlur={ this.inputOnBlur }
									onFocus={(e)=>this.inputFocus(e.target.value)} 
								></input>
								<ul className="search" style={{ display: (this.state.showBlock&&this.state.search.length>0) ? "block" : "none" }}
								>
									{this.state.search.map((item, index) => {
										return (
											<li key={index} onClick={(e) => { this.selectOptions( item.nsrsbh, item.nsrmc ); }}
											> {item.nsrmc}
											</li>
										);
									})}
								</ul>
							</li>

							<li style={{ display: this.state.toggle ? "block" : "none", }} >
								<label>
									<i>*</i>税号
								</label>
								<input autoComplete="off" placeholder="填写纳税人识别号" value={form.buyerRegistNo} onChange={(e) => { this.updateData(e, "buyerRegistNo"); }} />
							</li>

							<li className="email" style={{ display: "none" }}>
								<label>
									<i>*</i>邮箱
								</label>
								<input autoComplete="off" placeholder="填写邮箱信息、取票更快捷" value={form.email} onChange={(e) => { this.updateData(e, "email"); }} />
							</li>

							<li className="email" >
							    <label>
									<i>*</i>邮箱
								</label>
								<input autoComplete="off" placeholder="填写邮箱信息、取票更快捷" value={form.email} onChange={(e) => { this.updateData(e, "email"); }} />
								{/* <ul className="search" style={{ display: this.emailList.length > 0 ? "block" : "none", }} >
									{this.emailList.map((item, index) => {
										return (
											<li key={index} onClick={(e) => { this.selectEmaik( item ); }}> 
												{item}
											</li>
										);
									})}
								</ul> */}
							</li>
							<li>
								<label>手机号码</label>
								<input autoComplete="off"
									placeholder="选填、体验多种取票方式"
									value={form.phone}
									onChange={(e) => {
										this.updateData(e, "phone");
									}}
								></input>
							</li>


						 {/* {(this.state.tdyslxdm === '05' || this.state.tdyslxdm === '06') && (
								<>
								<li>
									<label>
									<i>*</i>跨地市标志
									</label>
									<Select
									showSearch
									onChange={(val) => this.setState({
										bdcInfo: {
										...this.state.bdcInfo,
										crossCitySign: val
										}
									})}
									className="selectBox"
									style={{"margin-left": "2%" }}
									optionFilterProp="hildren"
									value={this.state.bdcInfo?.crossCitySign || '0'}
									>
									<Option value="1">是</Option>
									<Option value="0">否</Option>
									</Select>
								</li>

								<li>
									<label>
									<i>*</i>面积单位
									</label>
									<Select
									onChange={(val) => this.setState({
										bdcInfo: {
										...this.state.bdcInfo,
										areaUnit: val
										}
									})}
									style={{"margin-left": "2%" ,
										"width": "105px"
									}}
									className="selectBox"
									value={this.state.bdcInfo?.areaUnit || 'm²'}
									>
									<Option value="m²">平方米</Option>
									<Option value="hm²">公顷</Option>
									<Option value="km²">平方千米</Option>
									</Select>
								</li>

								<li>
									<label>
									<i>*</i>不动产所在省市区
									</label>
									<Input 
									onChange={(v) => this.onChangeBdc('region', v)} 
									autoComplete="off" 
									value={this.state.bdcInfo?.region || ''}
									placeholder="请输入省市区"
									/>
								</li>

								<li>
									<label>
									<i>*</i>不动产详细地址
									</label>
									<Input 
									onChange={(v) => this.onChangeBdc('detailedAddress', v)} 
									autoComplete="off" 
									value={this.state.bdcInfo?.detailedAddress || ''}
									placeholder="请输入详细地址"
									/>
								</li>



								{this.state.tdyslxdm === '06' && (
									<>
									<li>
										<label>
										<i>*</i>房屋产权证书
										</label>
										<Input 
										onChange={(v) => this.onChangeBdc('titleNo', v)} 
										autoComplete="off" 
										value={this.state.bdcInfo?.titleNo || ''}
										placeholder="请输入产权证书编号"
										/>
									</li>

									<li>
										<label>
										<i>*</i>租赁期
										</label>
										<div style={{ display: 'flex', gap: '10px' }}>
										<DatePicker 
											onChange={(v, v1) => this.onChangeBdc1('zlqq', v1)} 
											format="YYYY-MM-DD" 
											placeholder="租赁期起"
											style={{ flex: 1 }}
										/>
										<DatePicker 
											onChange={(v, v1) => this.onChangeBdc1('zlqz', v1)} 
											format="YYYY-MM-DD" 
											placeholder="租赁期止"
											style={{ flex: 1 }}
										/>
										</div>
									</li>
									</>
								)}
								</>
							)} */}

							<li className="checkbox" style={{
									display: this.state.toggle ? "flex" : "none",
								}}>
								<input autoComplete="off"
									ref="oneCheckbox"
									id="oneCheckbox"
									type="checkbox"
									onClick={(e) => {
										this.setState({
											show: !this.state.show,
										});
									}}
									style={{verticalAlign:"middle"}}
								/>
								<label htmlFor="oneCheckbox" style={{width:'auto'}}>填写更多纳税人信息</label>
							</li>

							<ul
								style={{
									display: this.state.show ? "block" : "none",
								}}
							>
								<li>
									<label>经营地址</label>
									<input autoComplete="off"
										placeholder="选填、体验多种取票方式"
										value={form.buyerAddress=="undefined"?'':form.buyerAddress}
										onChange={(e) => {
											this.updateData(e, "buyerAddress");
										}}
									></input>
								</li>
								<li>
									<label>公司电话</label>
									<input autoComplete="off"
										placeholder="选填、体验多种取票方式"
										value={form.buyerPhone=="undefined"?'':form.buyerPhone}
										onChange={(e) => {
											this.updateData(e, "buyerPhone");
										}}
									></input>
								</li>
								<li>
									<label>开户行名称</label>
									<input autoComplete="off"
										placeholder="选填、体验多种取票方式"
										value={!form.buyerBankName?'':form.buyerBankName}
										onChange={(e) => {
											this.updateData( e, "buyerBankName" );
										}}
									></input>
								</li>
								<li>
									<label>开户行账号</label>
									<input autoComplete="off"
										placeholder="选填、体验多种取票方式"
										value={!form.buyerBankNo?'':form.buyerBankNo}
										onChange={(e) => {
											this.updateData( e, "buyerBankNo" );
										}}
									></input>
								</li>
							</ul>
						</ul>
					</div>
					<div className="btn">
						<button onClick={() => { this.writeInvoice(); }} >
							申请开票
						</button>
					</div>
				</div>
			</div>
			</Spin>
		);
	}
}
